import React from 'react'
import categories from 'keys/categories'
import TextPreview from './previews/TextPreview'
import ReadingComprehensionPreview from './previews/ReadingComprehensionPreview'
import FormatListNumberedRtlIcon from '@mui/icons-material/FormatListNumberedRtl'
import CloseIcon from '@mui/icons-material/Close'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import IconButton from '@mui/material/IconButton'


const PREVIEW_MAP = {
    [categories.NARRATIVE_TEXT]: TextPreview,
    [categories.NARRATIVE_TEXT_NO_NIKUD]: TextPreview,
    [categories.INFORMATIONAL_TEXT]: TextPreview,
    [categories.INFORMATIONAL_TEXT_NO_NIKUD]: TextPreview,
    [categories.BIBLICAL_TEXT]: TextPreview,
    [categories.MULTIPLE_CHOICE_QUESTIONS]: ReadingComprehensionPreview,
}

const AssessmentDefPreview = ({ data, categoryName, onClose  }) => {
    if (!data) return null

    const { title } = data
    const PreviewComponent = PREVIEW_MAP[categoryName] ?? TextPreview

    return (
        <>
            <div className="preview-header">
                 <div className="header-right">
                    <FormatListBulletedIcon fontSize="small" />
                    <span className="title">{title}</span>
                    
                </div>
                <IconButton size="small" onClick={onClose}>
                    <CloseIcon fontSize="small" />
                </IconButton>
               
            </div>
            <PreviewComponent data={data} />
        </>
    )
}

export default AssessmentDefPreview
